import axios from "axios";
const dyrectApi = process.env.REACT_APP_DYRECT_API_URL;

export const checkStripeAccount = async (receiverId) => {
  try {
    const path = `stripeStatus?receiverId=${receiverId}`;
    const response = await axios.get(`${dyrectApi}${path}`);
    console.log("Stripe account check response:", response.data);
    const parsedData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    return parsedData;
  } catch (error) {
    console.error("Error checking Stripe account:", error);
    throw error;
  }
};

export const getPaymentTransactions = async (userId, page = 1, limit = 10, type = 'sent') => {
  try {
    const response = await axios.get(`${dyrectApi}transactions?UserID=${userId}&page=${page}&limit=${limit}&type=${type}`);
    console.log("Payment transactions response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching payment transactions:", error);
    throw error;
  }
};

export const getStripeExpressDashboardLink = async (stripeAccountId) => {
  try {
    const path = "stripe/getDashboardLink";
    const response = await axios.post(`${dyrectApi}${path}`, {
      stripeAccountId: stripeAccountId
    });
    console.log("Stripe dashboard link response:", response.data);
    
    // Parse JSON string response
    let parsedData = response.data;
    if (typeof response.data === 'string') {
      parsedData = JSON.parse(response.data);
    }
    
    return parsedData;
  } catch (error) {
    console.error("Error getting Stripe dashboard link:", error);
    throw error;
  }
};

export const makePayment = async (senderUserId, receiverUserId, amount) => {
  try {
    const path = "payments";
    const response = await axios.post(`${dyrectApi}${path}`, {
      senderUserId,
      receiverUserId,
      amount
    });
    console.log("Payment checkout session response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating payment session:", error);
    throw error;
  }
};